import { AxiosResponse, AxiosError } from "axios";
import { useQuery } from "@tanstack/react-query";
import api from "../services/api";

export const PRODUCT_NAMES = {
  TCA_0207_URL_DYNAMIC_ANALYSIS: "TCA-0207-URL Dynamic Analysis"
};

interface QuotaExceededResponse {
  quota_exceeded: boolean;
}

const useQuotaExceededForProduct = (productName: string) => {
  const query = useQuery<AxiosResponse<QuotaExceededResponse>, AxiosError>({
    queryKey: ["quotaExceededForProduct", productName],
    queryFn: () => api.getQuotaExceededForProduct(productName)
  });

  return {
    isQuotaExceeded: query.data?.data?.quota_exceeded,
    isLoading: query.isLoading,
    error: query.error
  };
};

export default useQuotaExceededForProduct;
